import { render, staticRenderFns } from "./SourceImg.vue?vue&type=template&id=984fe220&scoped=true"
import script from "./SourceImg.vue?vue&type=script&lang=js"
export * from "./SourceImg.vue?vue&type=script&lang=js"
import style0 from "./SourceImg.vue?vue&type=style&index=0&id=984fe220&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984fe220",
  null
  
)

export default component.exports